module.exports = __webpack_public_path__ + "static/img/header_mPic_04.2cd8417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/mobile/header_mPic_04.png
// module id = tPY2
// module chunks = 0